import date from '../assets/svg/projects/date.svg'
import eatmore from '../assets/svg/projects/eatmore.svg'
import blood from '../assets/png/projects/eight.png'
import quiz from '../assets/svg/projects/quiz.svg'


export const UiData = [
    {
        id: 1,
        projectName: 'GoDate',
        projectDesc: 'UI design of dating app',
        tags: ['Figma'],
        code: 'https://www.figma.com/file/o7RsALcrdd0c369rulYK1X/Dating-App-UI?node-id=0%3A1&t=hKNBln9zBHvyLtb3-1',
        // demo: 'https://github.com/jyotirani123/BuyS_Monefy',
        image: date
    },
    {
        id: 2,
        projectName: 'Eat More',
        projectDesc: 'UI design of eat more app',
        tags: ['Adobe Xd'],
        code: 'https://xd.adobe.com/view/4e683441-9ce2-4aca-89a9-d6a4d3f4c9bb-1b3b/',
        // demo: 'https://prerna-gupta.web.app/',
        image: eatmore
    },
    {
        id: 3,
        projectName: 'Blood Bank',
        projectDesc: 'UI design of blood bank app.',
        tags: ['Adobe XD'],
        code: 'https://xd.adobe.com/view/0b0ceb38-8d77-44ec-9347-dd03451564ca-5e5f/screen/c863d535-3357-4867-8af0-c7f1bd581f94/',
        // demo: 'https://todo-list-879cd.web.app/',
        image: blood
    },
    {
        id: 4,
        projectName: 'Quiz App',
        projectDesc: 'UI design of Quiz app',
        tags: ['Figma' ],
        code: 'https://www.figma.com/file/8ItCnuy48F2yIjTZp1AppR/Quiz-App-UI?node-id=0%3A1&t=VfVNkRB49YDEGKIW-0',
        // demo: 'https://pokedex-7df36.web.app/',
        image: quiz
    },
]
